import { render, staticRenderFns } from "./NetworkTab.vue?vue&type=template&id=735e3655"
import script from "./NetworkTab.vue?vue&type=script&lang=js"
export * from "./NetworkTab.vue?vue&type=script&lang=js"
import style0 from "./NetworkTab.vue?vue&type=style&index=0&id=735e3655&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports